import { useEffect } from "react";

type ConfirmationSheetProps = {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ConfirmationSheet({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive,
  busy,
  onConfirm,
  onCancel,
}: ConfirmationSheetProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onCancel();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div className="staff-sheet-backdrop" role="presentation" onClick={onCancel}>
      <div
        className="staff-sheet"
        role="dialog"
        aria-modal="true"
        aria-labelledby="staff-confirm-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="staff-confirm-title" className="staff-sheet__title">{title}</h2>
        <p className="staff-sheet__message muted">{message}</p>
        <div className="staff-sheet__actions">
          <button type="button" className="secondary-button" onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={destructive ? "staff-button staff-button--danger" : "primary-button"}
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? "Working…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
